/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * type of Elec Tariff
 */
export type ProductType = (typeof ProductType)[keyof typeof ProductType]

export const ProductType = {
  Eco7: "Eco7",
  Standard: "Standard",
  TOU: "TOU",
} as const
